import React from "react";
import { useState, useEffect } from "react";
import News from "./News";
import Slider from "react-slick";
import { getSlider } from "../Service/Api";
import axios from "axios";
const HomeSlider = () => {
  const [sliderData, setSliderData] = useState([]);
  useEffect(function () {
    async function getSliderApi() {
      try {
        const res = await getSlider();
        console.log(res);
        setSliderData(res);
      } catch (err) {
        console.error(err);
      }
    }
    getSliderApi();
  }, []);

  console.log("what is slider data", sliderData);

  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
  };
  return (
    <>
      <div className="slider-sec">
        <div className="news">
          <News />
        </div>
        <div className="homeslider">
          <Slider {...settings}>
            {sliderData.length === 0 && (
              <div className="item">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/slider0.jpg"
                  alt="CCSDH"
                  className="img-fluid"
                />
              </div>
            )}

            {sliderData &&
              sliderData.map((item) => (
                <div className="item" key={item._id}>
                  <img
                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachment}`}
                    alt={item.title || "slider"}
                    className="img-fluid"
                  />
                </div>
              ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default HomeSlider;
